import { Injectable } from '@angular/core';
import {
  IKaraokeDTO,
  IKaraokePlayer,
  KaraokePlayer,
  IFormattedKaraokePlayer,
  FormattedKaraokePlayer,
} from '@app/infrastructure/models/grade-unit/karaoke';
import {
  IFormattedTranscriptWord,
  ITranscriptionResult,
  ITranscriptWord,
} from '@app/infrastructure/models/grade-unit/transcript';

import { TranscriptService } from './transcript.service';

@Injectable({
  providedIn: 'root',
})
export class KaraokePlayerService {
  constructor(private readonly transcriptService: TranscriptService) {}

  public mapKaraokeDTOToKaraokePlayer(karaokeDTO: IKaraokeDTO): IKaraokePlayer {
    if (!karaokeDTO) return;
    const karaokePlayer = new KaraokePlayer({
      audioUrl: karaokeDTO?.file?.signedUrl,
      transcriptWordList: this.setupTranscriptWordList(karaokeDTO),
      editedTranscriptWordList: this.setupEditedTranscriptWordList(karaokeDTO),
    });
    return karaokePlayer;
  }

  public mapToFormattedPlayer(
    karaokePlayer: IKaraokePlayer,
  ): IFormattedKaraokePlayer {
    if (!karaokePlayer) return;
    const formattedKaraokePlayer = new FormattedKaraokePlayer({
      audioUrl: karaokePlayer?.audioUrl,
      transcriptWordList: karaokePlayer?.editedTranscriptWordList?.length
        ? karaokePlayer?.editedTranscriptWordList
        : this.transcriptService.mapFormattingToTemplate(
            karaokePlayer?.transcriptWordList,
          ),
    });

    formattedKaraokePlayer.transcriptWordList.forEach((formattedGroup) =>
      this.transcriptService.sanitizeTextTimeData(formattedGroup.wordList),
    );

    return formattedKaraokePlayer;
  }

  private setupTranscriptWordList(karaokeDTO: IKaraokeDTO): ITranscriptWord[] {
    if (karaokeDTO.originalTranscription)
      return this.transcriptService.getTextTimeArrayFromTranscription(
        JSON.parse(karaokeDTO.originalTranscription) as ITranscriptionResult,
      );

    return [];
  }

  private setupEditedTranscriptWordList(
    karaokeDTO: IKaraokeDTO,
  ): IFormattedTranscriptWord[] {
    if (
      karaokeDTO.editedTranscription &&
      karaokeDTO.editedTranscription !== '[]'
    )
      return JSON.parse(
        karaokeDTO?.editedTranscription,
      ) as IFormattedTranscriptWord[];
    return null;
  }
}
